module.exports = __webpack_public_path__ + "static/media/Cafe_4.8203760c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/cafe/Cafe_4.png
// module id = 1322
// module chunks = 3